import moment from 'moment-timezone';

export const DISPLAY_TZ = 'Europe/Belgrade';

const DATE_TIME_FIELDS = ['time', 'timestamp'];
const DATE_FIELDS = [
  'createdAt',
  'birthday',
  'dateOfExpiredFrom',
  'dateOfExpiredTo',
  'fromDate',
  'toDate',
];

export const isDateField = field =>
  DATE_TIME_FIELDS.includes(field) || DATE_FIELDS.includes(field);

/**
 * Formats a date cell the same way on desktop and mobile.
 *  - `timestamp` (check-ins) is epoch SECONDS
 *  - `time` (logs) and the date-only fields are epoch MILLISECONDS
 * Everything is rendered in Europe/Belgrade regardless of the device's timezone/locale.
 */
export const formatDateCell = (field, value) => {
  if (value === null || value === undefined || value === '') return value;
  if (field === 'timestamp') {
    return moment.unix(value).tz(DISPLAY_TZ).format('DD/MM/YYYY HH:mm:ss');
  }
  if (field === 'time') {
    return moment(value).tz(DISPLAY_TZ).format('DD/MM/YYYY HH:mm:ss');
  }
  if (DATE_FIELDS.includes(field)) {
    return moment(value).tz(DISPLAY_TZ).format('DD/MM/YYYY');
  }
  return value;
};
